import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setUnauthorizedHandler } from '@/utils/request'
import '@/assets/css/global.css'

setUnauthorizedHandler(() => {
  if (router.currentRoute.value.path !== '/login') {
    router.replace({
      path: '/login',
      query: { redirect: router.currentRoute.value.fullPath }
    })
  }
})

createApp(App).use(router).mount('#app')
